










import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "cart-major-svg",
  props: {
    height: {
      type: String,
      default: () => {
        return "20px";
      },
    },
  },
});
